var _rect, _path, _rect2, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 98,
    viewBox: "0 0 156 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 22,
    width: 130,
    height: 75,
    rx: 3,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 23H128C129.105 23 130 23.8954 130 25V94C130 95.1046 129.105 96 128 96H97V23Z",
    fill: "#EC9770"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 22,
    width: 2,
    height: 74,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0402 71.7532C78.0902 72.3032 78.5766 72.7085 79.1266 72.6585C79.6766 72.6085 80.082 72.1221 80.032 71.5721L78.0402 71.7532ZM105.69 57.9192C106.108 57.558 106.154 56.9265 105.793 56.5087L99.907 49.6999C99.5459 49.282 98.9144 49.2361 98.4965 49.5973C98.0787 49.9585 98.0328 50.59 98.394 51.0078L103.626 57.06L97.5733 62.2917C97.1555 62.6528 97.1096 63.2843 97.4707 63.7022C97.8319 64.12 98.4634 64.1659 98.8812 63.8047L105.69 57.9192ZM80.032 71.5721C79.8097 69.1271 80.6954 65.4344 84.234 62.5223C87.7783 59.6055 94.1124 57.3708 104.964 58.16L105.109 56.1653C93.9597 55.3544 87.0438 57.6198 82.9631 60.978C78.8768 64.3409 77.7624 68.6981 78.0402 71.7532L80.032 71.5721Z",
    fill: "#624AB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.828 0.00727935C139.862 10.6707 134.621 11.696 132 11.6961C139.207 11.6961 141.172 20.9239 141.828 23.9999L141.828 24C141.828 18.8734 144.448 12.2087 151 11.696C143.138 11.696 141.892 -0.339899 141.828 0.00727935Z",
    fill: "#624AB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.69 20.0042C145.552 26.2246 142.517 26.8227 141 26.8227C145.172 26.8227 146.31 32.2056 146.69 34L146.69 34C146.69 31.0095 148.207 27.1217 152 26.8227C147.448 26.8227 146.727 19.8017 146.69 20.0042Z",
    fill: "#624AB6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.621 13.0027C151.897 17.0015 149.966 17.386 149 17.386C151.655 17.386 152.379 20.8465 152.621 22L152.621 22C152.621 20.0775 153.586 17.5783 156 17.386C153.103 17.386 152.644 12.8725 152.621 13.0027Z",
    fill: "#624AB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultIcon);
export default __webpack_public_path__ + "static/media/no_result_icon.877bea5bd6e3730161a9410b7dc62ea9.svg";
export { ForwardRef as ReactComponent };